<div class="right-panel"
     *ngIf="allNetworks.length >0">
  <div class="panel-header">
    <p class="panel-title">Create Roaming Community Membership</p>
  </div>
  <div class="panel-container">
    <form name="createRCM"
          class="createNS"
          #validate="ngForm">

      <div class="createNS-row">
        <label class="widget-create-title">Roaming Community
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <input class="widget-create-content"
               value="{{rcName}}"
               disabled/>
      </div>

      <div class="createNS-row">
        <label class="widget-create-title">Member NS
          <i class="fa fa-info-circle info-text"></i>
        </label>

        <div class="live-search">
          <ngx-select [allowClear]="true"
                     [items]="allNetworks"
                     (select)="selectedOwner($event)"
                     (remove)="removed($event)">
          </ngx-select>
        </div>

      </div>

      <div class="btn-area">
        <button (click)="backClicked()"
                class="custom-btn">Cancel
        </button>
        <button type="submit"
                class="custom-btn create-btn form-control"
                [ngClass]="{'disable': !isEnable}"
                [disabled]="!validate.valid || !isEnable"
                (click)="save()">Save
        </button>
      </div>
    </form>
  </div>
</div>
